import axios from 'axios';

export default {
  async getProductList(context, { sort, payload }) {
    const url = `${process.env.API_BASE_URL}/products/life${sort ? '?sort=' + sort : ''}`;
    try {
      const { data } = await axios.post(url, payload);
      const response = data;
      return context.commit('setListProduct', response.data);
    } catch (error) {
      return error;
    }
  }
};
